/* eslint-disable */
import GraphQL from '../../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RenderingAndLighthouseWebsitesQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type RenderingAndLighthouseWebsitesQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly websites: ReadonlyArray<{ readonly __typename?: 'Website', readonly displayName: string, readonly id: CK.WebsiteId, readonly isDomTracked: boolean, readonly isLighthouseMonitored: boolean }> } | null };


export const RenderingAndLighthouseWebsitesDocument = gql`
    query RenderingAndLighthouseWebsites($accountId: AccountId!) {
  account(id: $accountId) {
    id
    websites {
      displayName
      id
      isDomTracked
      isLighthouseMonitored
    }
  }
}
    `;

/**
 * __useRenderingAndLighthouseWebsitesQuery__
 *
 * To run a query within a React component, call `useRenderingAndLighthouseWebsitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderingAndLighthouseWebsitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderingAndLighthouseWebsitesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useRenderingAndLighthouseWebsitesQuery(baseOptions: Apollo.QueryHookOptions<RenderingAndLighthouseWebsitesQuery, RenderingAndLighthouseWebsitesQueryVariables> & ({ variables: RenderingAndLighthouseWebsitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenderingAndLighthouseWebsitesQuery, RenderingAndLighthouseWebsitesQueryVariables>(RenderingAndLighthouseWebsitesDocument, options);
      }
export function useRenderingAndLighthouseWebsitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenderingAndLighthouseWebsitesQuery, RenderingAndLighthouseWebsitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenderingAndLighthouseWebsitesQuery, RenderingAndLighthouseWebsitesQueryVariables>(RenderingAndLighthouseWebsitesDocument, options);
        }
export function useRenderingAndLighthouseWebsitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenderingAndLighthouseWebsitesQuery, RenderingAndLighthouseWebsitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RenderingAndLighthouseWebsitesQuery, RenderingAndLighthouseWebsitesQueryVariables>(RenderingAndLighthouseWebsitesDocument, options);
        }
export type RenderingAndLighthouseWebsitesQueryHookResult = ReturnType<typeof useRenderingAndLighthouseWebsitesQuery>;
export type RenderingAndLighthouseWebsitesLazyQueryHookResult = ReturnType<typeof useRenderingAndLighthouseWebsitesLazyQuery>;
export type RenderingAndLighthouseWebsitesSuspenseQueryHookResult = ReturnType<typeof useRenderingAndLighthouseWebsitesSuspenseQuery>;
export type RenderingAndLighthouseWebsitesQueryResult = Apollo.QueryResult<RenderingAndLighthouseWebsitesQuery, RenderingAndLighthouseWebsitesQueryVariables>;